import { UpdateOn, ValidateOn } from "react-redux-form";

export const mapProps = {
  valid: ({ fieldValue }) => fieldValue.valid,
  touched: ({ fieldValue }) => fieldValue.touched
};

export const validateOn: ValidateOn[] = ["blur", "change"];

export const updateOn: UpdateOn[] = ["change"];

export const showErrors = { touched: true };



// WEBPACK FOOTER //
// ./src/components/Controls/ReactReduxFormSettings.ts